'use client';

import { Search, X } from 'lucide-react';
import { useState, useEffect } from 'react';

interface SearchBarProps {
    onSearch: (query: string) => void;
    placeholder?: string;
}

export default function SearchBar({ onSearch, placeholder = "Cari artikel..." }: SearchBarProps) {
    const [query, setQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            onSearch(query);
        }, 300);

        return () => clearTimeout(debounceTimer);
    }, [query, onSearch]);

    const handleClear = () => {
        setQuery('');
        onSearch('');
    };

    return (
        <div data-component-id="src\components\blog\SearchBar.tsx:29:8" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="29" data-component-end-line="70" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-2xl%20mx-auto%20mb-8%20sm%3Amb-12%22%7D" className="w-full max-w-2xl mx-auto mb-8 sm:mb-12">
            <div data-component-id="src\components\blog\SearchBar.tsx:30:12" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="30" data-component-end-line="61" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                className={`relative flex items-center bg-white rounded-2xl shadow-lg transition-all duration-300 ${isFocused ? 'ring-2 ring-primary-accent shadow-xl' : 'shadow-md'
                    }`}
            >
                <div data-component-id="src\components\blog\SearchBar.tsx:34:16" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="34" data-component-end-line="40" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-4%20sm%3Aleft-5%20flex%20items-center%20pointer-events-none%22%7D" className="absolute left-4 sm:left-5 flex items-center pointer-events-none">
                    <Search data-component-id="src\components\blog\SearchBar.tsx:35:20" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="35" data-component-end-line="39" data-component-file="SearchBar.tsx" data-component-name="Search" data-component-content="%7B%22elementName%22%3A%22Search%22%7D"
                        className={`transition-colors duration-300 ${isFocused ? 'text-primary-accent' : 'text-gray-400'
                            }`}
                        size={20}
                    />
                </div>

                <input data-component-id="src\components\blog\SearchBar.tsx:42:16" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="42" data-component-end-line="50" data-component-file="SearchBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3Aquery%5D%22%2C%22className%22%3A%22w-full%20py-4%20px-12%20sm%3Apx-14%20text-base%20sm%3Atext-lg%20bg-transparent%20outline-none%20text-gray-800%20placeholder-gray-400%22%7D"
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    placeholder={placeholder}
                    className="w-full py-4 px-12 sm:px-14 text-base sm:text-lg bg-transparent outline-none text-gray-800 placeholder-gray-400"
                />

                {query && (
                    <button data-component-id="src\components\blog\SearchBar.tsx:53:20" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="53" data-component-end-line="59" data-component-file="SearchBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20sm%3Aright-5%20flex%20items-center%20justify-center%20w-6%20h-6%20rounded-full%20bg-gray-200%20hover%3Abg-gray-300%20transition-colors%20duration-200%22%7D"
                        onClick={handleClear}
                        className="absolute right-4 sm:right-5 flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-200"
                        aria-label="Clear search"
                    >
                        <X data-component-id="src\components\blog\SearchBar.tsx:58:24" data-component-path="src\components\blog\SearchBar.tsx" data-component-line="58" data-component-end-line="58" data-component-file="SearchBar.tsx" data-component-name="X" data-component-content="%7B%22elementName%22%3A%22X%22%2C%22className%22%3A%22text-gray-600%22%7D" size={14} className="text-gray-600" />
                    </button>
                )}
            </div>

            {/* {query && (
                <div className="mt-3 text-center">
                    <p className="text-sm text-gray-600">
                        Mencari: <span className="font-semibold text-primary-accent">{query}</span>
                    </p>
                </div>
            )} */}
        </div>
    );
}
